module.exports = __webpack_public_path__ + "static/media/delete.c3b409fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/delete.svg
// module id = 317
// module chunks = 0